<template>
  <div class="of-content-5">
    <topper
      v-if="Object.keys(ofContent5.topper).length > 0"
      class="of-content-5-item"
      :view="ofContent5.topper"
    />
    <category class="of-content-5-item" :view="ofContent5.category">
      <item
        slot="categoryItem"
        slot-scope="props"
        :view="props.item"
      />
    </category>
  </div>
</template>


<script>
  import item from "./item.vue";
  import topper from "./topper.vue";
  import category from "./category.vue"

  export default {
    name: "of-content-5",
    props: ["view"],
    components: {
      "item": item,
      "topper": topper,
      "category": category
    },
    data() {
      return {
        topper: {
          mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-5/ic-training-topper.svg',
          title: 'TRAINING BUILDERALL',
          text: 'We Provide Every Other Tool You Will Ever Need To Explode Your Business Online!'
        },
        category: {
          title: "CATEGORY",
          items: [
            { /* item1 */
              mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-5/ic-training-card.svg',
              title: "Marketing Afiliados",
              text: 'Auctor aliquam ut quam nibh consequat sociosqu senectus condimentum feugiat.',
              button: {
                text: "Learn more",
                link: "#"
              },
              baIntelligenceTag: 'fc-c5-affiliate-marketing'
            },
            { /* item2 */
              mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-5/ic-training-card.svg',
              title: "Marketing Afiliados",
              text: 'Auctor aliquam ut quam nibh consequat sociosqu senectus condimentum feugiat.',
              button: {
                text: "Learn more",
                link: "#"
              },
              baIntelligenceTag: 'fc-c5-affiliate-marketing'
            },
            { /* item3 */
              mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-5/ic-training-card.svg',
              title: "Marketing Afiliados",
              text: 'Auctor aliquam ut quam nibh consequat sociosqu senectus condimentum feugiat.',
              button: {
                text: "Learn more",
                link: "#"
              },
              baIntelligenceTag: 'fc-c5-affiliate-marketing'
            }
          ]
        }
      }
    },
    computed: {
        ofContent5: function () {
            return (this.view !== undefined && this.view !== null) ? this.view : this.$data
        }
    },
    created() {},
    mounted() {}
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../../../../scss/office";

.of-content-5 {
  font: inherit;

  display: grid;
  grid-template-columns: 1fr; /* grid de 6fr */
  grid-template-rows: auto auto;
  column-gap: 2.4em; /* 24px */
  row-gap: 2.4em; /* 24px */
  justify-items: stretch;
  align-items: stretch;
  justify-content: stretch;
  align-content: space-between;

  margin-bottom: 2.7em!important; /* 27px */
  
  .of-content-5-item{
    font: inherit;
  }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/dashboard/onboardingFunnel/content-5/index.vue